import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Datenschutz() {
	return (
		<div className="page-layout">
			<Header title="Datenschutz" />

			{/* Hero Section */}
			<section className="hero-section bg-light py-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-8">
							<h1 className="display-4 fw-bold mb-3">Datenschutz</h1>
							<p className="lead mb-4">Datenschutz auf einen Blick</p>
						</div>
					</div>
				</div>
			</section>

			<section className="py-5">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="content-body">
								<div className="row mb-4">
									<div className="col-md-6">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Allgemeine Hinweise</h3>
											<p className="mb-0 small">Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
										</div>
									</div>
									<div className="col-md-6">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Datenerfassung auf dieser Website</h3>
											<p className="mb-0 small">Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p>
										</div>
									</div>
								</div>

								<div className="row mb-4">
									<div className="col-lg-4 col-md-6">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Wie erfassen wir Ihre Daten?</h3>
											<p className="mb-0 small">Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst.</p>
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Wofür nutzen wir Ihre Daten?</h3>
											<p className="mb-0 small">Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>
										</div>
									</div>
									<div className="col-lg-4 col-md-12">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Welche Rechte haben Sie?</h3>
											<p className="mb-0 small">Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.</p>
										</div>
									</div>
								</div>

								<div className="bg-light rounded p-4 mb-4">
									<h2 className="h4 text-primary fw-bold mb-3">2. Hosting</h2>
									<h3 className="h5 text-primary fw-bold mb-3">Externes Hosting</h3>
									<p className="mb-0">
										Diese Website wird bei Amazon Web Services (AWS) gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern von AWS gespeichert. Hierbei kann es sich v.a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln. AWS verarbeitet diese Daten in unserem Auftrag gemäß Art. 28 DSGVO.
									</p>
								</div>

								<div className="bg-light rounded p-4 mb-4">
									<h2 className="h4 text-primary fw-bold mb-3">3. Allgemeine Hinweise und Pflichtinformationen</h2>
									<div className="row">
										<div className="col-md-6">
											<h3 className="h5 text-primary fw-bold mb-3">Datenschutz</h3>
											<p className="mb-3 small">Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>
										</div>
										<div className="col-md-6">
											<h3 className="h5 text-primary fw-bold mb-3">Hinweis zur verantwortlichen Stelle</h3>
											<p className="mb-3 small">Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist: Sebastian Jonas, Neue Str. 17B, 30974, E-Mail: thankwich@rosch.io</p>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<h3 className="h5 text-primary fw-bold mb-3">Speicherdauer</h3>
											<p className="mb-0 small">Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.</p>
										</div>
										<div className="col-md-6">
											<h3 className="h5 text-primary fw-bold mb-3">Widerruf Ihrer Einwilligung</h3>
											<p className="mb-0 small">Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</p>
										</div>
									</div>
								</div>

								<div className="bg-light rounded p-4">
									<h2 className="h4 text-primary fw-bold mb-3">4. Cookies</h2>
									<div className="row">
										<div className="col-lg-4 col-md-6">
											<h3 className="h5 text-primary fw-bold mb-3">Was sind Cookies?</h3>
											<p className="mb-0 small">Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden. Sie werden von den meisten Websites verwendet, um die Benutzerfreundlichkeit zu verbessern und die Website-Funktionalität zu gewährleisten.</p>
										</div>
										<div className="col-lg-4 col-md-6">
											<h3 className="h5 text-primary fw-bold mb-3">Verwendung von Cookies</h3>
											<p className="mb-0 small">Diese Website verwendet derzeit keine Cookies. Falls in Zukunft Cookies eingesetzt werden, werden Sie hierüber informiert und können Ihre Einwilligung erteilen oder verweigern.</p>
										</div>
										<div className="col-lg-4 col-md-12">
											<h3 className="h5 text-primary fw-bold mb-3">Cookie-Einstellungen</h3>
											<p className="mb-0 small">Sie können Cookies in Ihrem Browser jederzeit deaktivieren oder löschen. Beachten Sie jedoch, dass dies die Funktionalität der Website beeinträchtigen kann.</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</div>
	);
}

export default Datenschutz;
